import React from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { Box, Stack, Typography } from "@mui/material";
import GlobalButton from "../../components/button";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { t } from "i18next";

const cardElementOptions = {
  style: {
    base: {
      color: "#000000",
      fontFamily: "'Roboto', sans-serif",
      fontSize: "15px",
      fontWeight: "500",
      letterSpacing: "0.025em",
      backgroundColor: "#f9f9f9",
      padding: "10px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      "::placeholder": {
        color: "#888888",
      },
    },
    invalid: {
      color: "#ff5252",
      iconColor: "#ff5252",
    },
  },
  hidePostalCode: true,
};

const PaymentForm = ({ handlBooked }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { showSnackbar } = useSnackbar();
  return (
    <React.Fragment>
      <Typography variant="body2" mb={0.5}>
        {t("enterCardDetail")}.
      </Typography>
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
        }}
      >
        <CardElement options={cardElementOptions} />
      </Box>
      <Stack mt={2}>
        <GlobalButton
          btnText={t("bookAppointment")}
          handleClickBtn={async () => {
            if (!stripe || !elements) {
              return showSnackbar(t("stripeNotLoaded"), "error");
            }
            const cardElement = elements.getElement(CardElement);
            const { token, error } = await stripe.createToken(cardElement);

            if (error) {
              showSnackbar(error.message, "error");
              return;
            }
            handlBooked(token);
          }}
        />
      </Stack>
    </React.Fragment>
  );
};

export default PaymentForm;
